const initialState = { token: '', expired: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, token: action.user.token };
    case 'SET_AUTH_EXPIRED':
      return { ...state, expired: true };
    case 'CLEAR_AUTH_EXPIRED':
      return { ...state, expired: false };
    case 'CLEAR':
      return { ...initialState, expired: state.expired };
    default:
      return state;
  }
};
